import React from "react";
import { FormGroup, ModalBody, ModalHeader, Input, Label, Button, Form } from "reactstrap";
import SimpleReactValidator from "simple-react-validator";
import { addCity, updateCity} from "../../../services/cityService";
import { notifyError, notifySuccess } from "../../../utils/utils";
import Loader from "../../../utils/Loader";

class AddCity extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            city: "",
            loading: false
        };

        this.validator = new SimpleReactValidator({
            locale: 'en', messages:{}, autoForceUpdate: this
        });

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleResponse = this.handleResponse.bind(this);
    }

    handleSubmit(e) {
        e.preventDefault();
        if(!this.validator.allValid()){
            this.validator.showMessages();
            this.forceUpdate();
            return;
        }
        const data = { name: this.state.city};
        this.setState({ loading: true });

        if(this.props.isEditing) {
            updateCity(this.state.id, data)
            .then(res => this.handleResponse(res.data))
        } else {
            addCity(data).then(res => this.handleResponse(res.data)); 
        }
    }

    handleResponse(data) {
        

        if(data.status) {
            notifySuccess(data.message);
            // setTimeout(() => {
                this.props.toggle();
                this.props.reload();
                // }, 1000);
            } else {
            this.setState({ loading: false });
            notifyError(data.message);
        }
    }

    
    componentDidMount(){
        if(this.props.isEditing){
            this.setState({
                city: this.props.city.name,
                id: this.props.city.city_id
            });
        }
    }

    render() {
        this.validator.purgeFields();

        const { city } = this.state;

        return(

            <React.Fragment>
                {/* <div className="page-content">
                    <Container fluid> */}
                        <ModalHeader toggle={() => this.props.toggle()}> 
                            {this.props.isEditing ? "Edit" : "Add"} City
                        </ModalHeader>
                        <ModalBody>
                       
                            <Form onSubmit={this.handleSubmit} autoComplete="off">  

                                <FormGroup>
                                    <Label>City</Label>
                                    <Input
                                        type="text"
                                        name="city"
                                        value={city}
                                        onChange={e => {
                                            this.setState({
                                                city: e.target.value
                                            });
                                        }}
                                    />
                                <span className="text-danger">
                                    {this.validator.message('City name', city, 'required|alpha_num_space|min:5|max:30')}
                                </span>
                                </FormGroup>
                                
                                <FormGroup className="pull-right">
                            {
                                this.state.loading
                                    ?
                                    <Loader />
                                    // <Spinner style={{ width: '3rem', height: '3rem' }}  color="primary" />
                                    :
                                    <Button color="success" type="submit">Submit</Button> 
                            }
                                        {/* <Button color="success" type="submit">Submit</Button> */}
                                </FormGroup>
                            </Form>
                        </ModalBody>
                    {/* </Container>
                </div> */}
            </React.Fragment>
        )
    }
}

export default AddCity;